import { render } from "./SearchProducts.vue?vue&type=template&id=21af1d54&ts=true"
import script from "./SearchProducts.vue?vue&type=script&lang=ts"
export * from "./SearchProducts.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-pim-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__